import React from "react";

import ClientStrategyPage from "containers/admin/clients/client/components/client-strategy-page/client-strategy-page";

import { ClientStrategyCategoryDTOStrategyCategory } from "generated/schemas";

const PartnerPage: React.FC = () => (
  <ClientStrategyPage
    strategyCategory={ClientStrategyCategoryDTOStrategyCategory.PARTNER}
    formId="partner-form"
    sidebarSectionId="partner-nav"
    emptyMessage="Partnership template is not available."
    saveSuccessTitle="Partnership saved"
    saveErrorTitle="Could not save partnership"
    editButtonLabel="Edit partnership"
    header={{ title: "Partnership" }}
    breadcrumb={{
      parents: [{ label: "Strategy", active: false }],
      label: "Partnership",
      pathKey: "clientPartnerPath",
      includeActiveTab: false,
    }}
  />
);

export default PartnerPage;
